import React from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import { SC_sc, SC_sc_drfQueue } from "../../SC/__generated__/SC";
import { Table, Button } from "antd";
import assign from "lodash.assign";

const DISBANDQUEUEADD = gql`
  mutation DISBANDQUEUEADD(
    $sc: ID!
    $pop: String!
    $race: Int!
    $amount: Float!
  ) {
    drfQueueAdd(sc: $sc, pop: $pop, race: $race, amount: $amount) {
      sc
    }
  }
`;

const DISBANDQUEUEREMOVE = gql`
  mutation DISBANDQUEUEREMOVE($sc: ID!, $pop: String!, $race: Int!) {
    drfQueueRemove(sc: $sc, pop: $pop, race: $race) {
      sc
    }
  }
`;

interface Props {
  sc: SC_sc;
  drfQueues: SC_sc_drfQueue[];
  reload: any;
}

export const Disband = ({ sc, drfQueues, reload }: Props) => {
  const [addDraft] = useMutation(DISBANDQUEUEADD);
  const [removeDraft] = useMutation(DISBANDQUEUEREMOVE);

  const handleAddDraft = async (
    sc: SC_sc,
    pop: string,
    race: number,
    amount: number
  ) => {
    await addDraft({ variables: { sc, pop, race, amount } });
    reload();
  };

  const handleRemoveDraft = async (sc: string, pop: string, race: number) => {
    await removeDraft({ variables: { sc, pop, race } });
    reload();
  };

  var children: JSX.Element[] = [];

  children.push(<br key="Draft break" />);
  children.push(
    <h3 key={"Draft/Disband Population"}>Population Operations</h3>
  );

  const sorted = drfQueues.sort((a, b) =>
    b.pop < a.pop ? 1 : a.pop > b.pop ? -1 : b.race - a.race
  );

  function formatNumber(num: number) {
    num = Math.floor(num);
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  function formatStatus(
    amount: number,
    original: number,
    pop: string,
    race: number
  ) {
    const direction = original > 0 ? "Drafted" : "Disbanded";
    const completed =
      original > 0
        ? formatNumber(original - amount)
        : formatNumber(-(original - amount));
    const target =
      original > 0 ? formatNumber(original) : formatNumber(-original);

    return (
      completed + " of " + target + " " + pop + "-" + race + " " + direction
    );
  }

  const draftColumns = [
    {
      title: <p style={{ textAlign: "center" }}>Orders</p>,
      dataIndex: "status",
      key: "draftStatus",
      render: (text: string) => <p style={{ textAlign: "center" }}>{text}</p>,
    },
    {
      title: <p style={{ textAlign: "center" }}>Status</p>,
      dataIndex: "cancel",
      key: "draftCancel",
      render: (value: any) => (
        <Button
          block
          onClick={() => handleRemoveDraft(sc.sc, value.pop, value.race)}
        >
          {"Cancel "}
          {value.pop}-{value.race}
          {" Order"}
        </Button>
      ),
    },
  ];

  let draftData: any = [];

  sorted.forEach((q) => {
    draftData.push(
      assign({
        key: q.pop + q.race,
        cancel: q,
        status: formatStatus(q.amount, q.original, q.pop, q.race),
      })
    );
  });

  children.push(
    <Table
      key="DraftTable"
      size="middle"
      dataSource={draftData}
      columns={draftColumns}
    />
  );

  return <div>{children}</div>;
};
